import { Tooltip, Zoom, IconButton } from '@material-ui/core';
import { Edit as EditIcon } from '@material-ui/icons';
import { Link } from 'react-router-dom';


interface IProps {
    size?: 'small' | 'medium'
    link?: string
    stopPropagation?: boolean
    onClick?: () => void
}

let EditIconButton = ({ size = 'small', link, stopPropagation, onClick }: IProps) => {
    return (
        <Tooltip title="Edit" TransitionComponent={Zoom}>
            <>
                {link !== undefined && link !== null &&
                    <IconButton
                        size={size}
                        color="primary"
                        component={Link}
                        to={link}
                        onClick={(ev: any) => { if (stopPropagation === true) ev.stopPropagation() }}
                    >
                        <EditIcon />
                    </IconButton>
                }
                {(link === undefined || link === null) &&
                    <IconButton
                        size={size}
                        color="primary"
                        onClick={ev => {
                            if (stopPropagation === true) {
                                ev.stopPropagation();
                            }

                            if (onClick)
                                onClick();
                        }}
                    >
                        <EditIcon />
                    </IconButton>
                }
            </>
        </Tooltip>
    )
}

export default EditIconButton;